import axiosAuth from '../../axiosMain';

async function index() {
  try {
    let response = await axiosAuth.get('/providers');
    return response.data.data;
  } catch (e) {}
}

async function store(data) {
  let response = await axiosAuth.post('/providers', data);
  return response.data.data;
}

export default {
  index,
  store,
};
